<mat-form-field [appearance]="appearance" fxFlex *ngIf="!selectedEquipmentType">
  <mat-label *ngIf="floatLabel">
    {{ 'EQUIPMENTS_TYPES_SEARCH.TITLE' | translate }}
  </mat-label>
  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
    [required]="required"
    [placeholder]="'EQUIPMENTS_TYPES_SEARCH.PLACEHOLDER' | translate"
    fxFlex="90"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedEquipmentType()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let equipmentType of equipmentsType" [value]="equipmentType.id">
      {{ equipmentType.name }}
    </mat-option>
    <mat-option *ngIf="!equipmentsType.length">
      {{ 'EQUIPMENTS_TYPES_SEARCH.NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>

  <mat-error>
    {{ 'EQUIPMENTS_TYPES_SEARCH.ERROR' | translate }}
  </mat-error>
</mat-form-field>

<mat-form-field [appearance]="appearance" fxFlex *ngIf="selectedEquipmentType">
  <mat-label *ngIf="floatLabel">
    {{ 'EQUIPMENTS_TYPES_SEARCH.TITLE' | translate }}
  </mat-label>
  <div class="flex">
    <input type="text" matInput [value]="selectedEquipmentType.name" disabled required />
    <button
      [disabled]="disabled"
      mat-icon-button
      class="my-cancel-button accent-700-fg"
      (click)="deselectEquipmentType()"
    >
      <mat-icon class="font-size-20">cancel</mat-icon>
    </button>
  </div>
</mat-form-field>
